module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/philosophy01-5491f5e706db3f397813fde268033b5a.png";